import React, { useState } from 'react';

import { Flex } from '../../styles/globalStyles';
import { Tabs, Tab } from '../../styles/commonStyles';
import { BiCheck } from 'react-icons/bi';

const FILTERLIST = ['최신순', '오래된순'];

const FilterTabs = props => {
  const { rtValue, dark } = props;
  const [tabValue, setTabValue] = useState(0);

  const changeTabValue = e => {
    let value = Number(e.target.value);

    rtValue(value);
    setTabValue(value);
  };

  return (
    <>
      <Flex className='filter_tabs'>
        <Tabs option='filter' dark={dark}>
          {FILTERLIST.map((list, idx) => {
            return (
              <Tab key={`tab_${idx}`} option='filter' dark={dark} value={`${idx}`} onClick={changeTabValue} active={tabValue === idx}>
                {tabValue === idx && <BiCheck />}
                {list}
              </Tab>
            );
          })}
        </Tabs>
      </Flex>
    </>
  );
};

export default FilterTabs;
